export default () => {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_48_930)">
        <path
          d="M9 0.5H3C2.173 0.5 1.5 1.173 1.5 2V11C1.5 11.827 2.173 12.5 3 12.5H9C9.827 12.5 10.5 11.827 10.5 11V2C10.5 1.173 9.827 0.5 9 0.5ZM6 11.5C5.724 11.5 5.5 11.276 5.5 11C5.5 10.724 5.724 10.5 6 10.5C6.276 10.5 6.5 10.724 6.5 11C6.5 11.276 6.276 11.5 6 11.5ZM9.5 9C9.5 9.276 9.276 9.5 9 9.5H3C2.724 9.5 2.5 9.276 2.5 9V2.5C2.5 2.224 2.724 2 3 2H9C9.276 2 9.5 2.224 9.5 2.5V9Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_48_930">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
